module.exports = __webpack_public_path__ + "img/an26.314fc322.png";